exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn[data-v-21e26666] {\n    border: 1px solid #DEDEDE !important;\n    border-radius: 0.1875rem !important;\n    box-shadow: none !important;\n}\n\n/* hide checkbox  */\n.btn input[type=checkbox][data-v-21e26666] {\n    position: absolute;\n    clip: rect(0, 0, 0, 0);\n    pointer-events: none;\n}\n", ""]);

// exports
